import { IContext } from './dto';
import { ContextPart } from './';

export const IApiServiceContract: symbol = Symbol.for('IApiService');

export interface IApiService {

    getContextPart(part: ContextPart): Promise<IContext>;
    postContext(context: IContext): Promise<void>;

}
